export enum MetricName {
    USER_SESSION = "USER_SESSION",
    MAP_LOADING = "MAP_LOADING",
    MAPBOX_LOADING = "MAPBOX_LOADING",
    PLAN_CREATED = "PLAN_CREATED",
    PLAN_LOADED = "PLAN_LOADED",
    PLAN_EXPORTED_PNG = "PLAN_EXPORTED_PNG",
    PLAN_EXPORTED_PDF = "PLAN_EXPORTED_PDF",
    MAP_OBJECTS_EXPORTED_GEOJSON = "MAP_OBJECTS_EXPORTED_GEOJSON",
    MAP_OBJECTS_EXPORTED_KML = "MAP_OBJECTS_EXPORTED_KML",
    MAP_OBJECTS_IMPORTED_GEOJSON = "MAP_OBJECTS_IMPORTED_GEOJSON",
    MAP_OBJECTS_IMPORTED_KML = "MAP_OBJECTS_IMPORTED_KML",
    MAP_OBJECTS_IMPORTED_KMZ = "MAP_OBJECTS_IMPORTED_KMZ",
    AREA_LAYER_CREATED = "AREA_LAYER_CREATED",
    LINE_LAYER_CREATED = "LINE_LAYER_CREATED",
    POINT_LAYER_CREATED = "POINT_LAYER_CREATED",
    ICON_LAYER_CREATED = "ICON_LAYER_CREATED",
    MODEL_LAYER_CREATED = "MODEL_LAYER_CREATED",
    LINE_MODEL_LAYER_CREATED = "LINE_MODEL_LAYER_CREATED",
    AREA_OF_MODEL_LAYER_CREATED = "AREA_OF_MODEL_LAYER_CREATED",
    DATA_TABLE_USED = "DATA_TABLE_USED",
    PLAN_SHARED = "PLAN_SHARED",
    PLAN_SEARCHED = "PLAN_SEARCHED",
    DATE_FILTER_USED = "DATE_FILTER_USED",
    DIGITAL_TWIN_USED = "DIGITAL_TWIN_USED",
    DELETE_LAYER = "DELETE_LAYER",
    IMPORT_LAYER = "IMPORT_LAYER",
    DISTANCE_ANALYSIS_USED = "DISTANCE_ANALYSIS_USED",
    WALK_TIME_ANALYSIS_USED = "WALK_TIME_ANALYSIS_USED",
    FLOW_RATE_ANALYSIS_USED = "FLOW_RATE_ANALYSIS_USED",
    AREA_ANALYSIS_USED = "AREA_ANALYSIS_USED",
    CAPACITY_ANALYSIS_USED = "CAPACITY_ANALYSIS_USED",
    COUNT_ANALYSIS_USED = "COUNT_ANALYSIS_USED",
    PLAN_3D_TERRAIN_USED = "PLAN_3D_TERRAIN_USED",
    PLAN_3D_BUILDINGS_USED = "PLAN_3D_BUILDINGS_USED",
    BACKGROUND_MAP_SELECTED = "BACKGROUND_MAP_SELECTED",
    SITEMAP_SELECTOR_USED = "SITEMAP_SELECTOR_USED",
    SITEMAP_LEVEL_USED = "SITEMAP_LEVEL_USED",
    COMMENT_CREATED = "COMMENT_CREATED",
    COMMENT_SELECTED = "COMMENT_SELECTED",
    MAP_OBJECT_CREATED = "MAP_OBJECT_CREATED",
    COPY_MAP_OBJECT_USED = "COPY_MAP_OBJECT_USED",
    FIXED_SHAPE_MAP_OBJECT_USED = "FIXED_SHAPE_MAP_OBJECT_USED",
    ROUTE_MAP_OBJECT_USED = "ROUTE_MAP_OBJECT_USED",
    DRAW_MAP_OBJECT_USED = "DRAW_MAP_OBJECT_USED",
    NOTIFICATIONS_VIEWED = "NOTIFICATIONS_VIEWED",
    CREATE_DATAFIELD = "CREATE_DATAFIELD",
    DELETE_DATAFIELD = "DELETE_DATAFIELD",
    MOVE_LAYER_TO_BACK = "MOVE_LAYER_TO_BACK",
    MOVE_LAYER_TO_FRONT = "MOVE_LAYER_TO_FRONT",
    MODEL_IMAGE_CHANGES = "MODEL_IMAGE_CHANGES",
    MODEL_COLOUR_CHANGES = "MODEL_COLOUR_CHANGES",
    SNAP_MAP_OBJECT_USED = "SNAP_MAP_OBJECT_USED",
    MAP_UNDO = "MAP_UNDO",
    MAP_REDO = "MAP_REDO",
    PLANS_COPIED = "PLANS_COPIED",
    VENUE_BOOKMARK_CREATED = "VENUE_BOOKMARK_CREATED",
    VENUE_BOOKMARK_SELECTED = "VENUE_BOOKMARK_SELECTED",
    MAP_SHARED_LINK_EXPIRY_THREEDAYS = "MAP_SHARED_LINK_EXPIRY_THREEDAYS",
    MAP_SHARED_LINK_EXPIRY_SEVENDAYS = "MAP_SHARED_LINK_EXPIRY_SEVENDAYS",
    MAP_SHARED_LINK_EXPIRY_FOURTEENDAYS = "MAP_SHARED_LINK_EXPIRY_FOURTEENDAYS",
    MAP_SHARED_LINK_EXPIRY_THIRTYDAYS = "MAP_SHARED_LINK_EXPIRY_THIRTYDAYS",
    PLANNER_SCREENSHOT = "PLANNER_SCREENSHOT",
    DIGITAL_TWIN_SCREENSHOT = "DIGITAL_TWIN_SCREENSHOT",
    MAP_OBJECTS_EXPORTED_DWG = "MAP_OBJECTS_EXPORTED_DWG",
    ROUTE_CONVERT_TO_LINE = "ROUTE_CONVERT_TO_LINE",
    COPY_LAYERS = "COPY_LAYERS",
    COPY_LAYERS_AND_GROUPS = "COPY_LAYERS_AND_GROUPS",
    UNLINK_LAYERS = "UNLINK_LAYERS",
    PLAN_CHANGE_LOG = "PLAN_CHANGE_LOG",
    SPLIT_LINE = "SPLIT_LINE",
    PROJECT_LAYER_TEMPLATE_CREATED = "PROJECT_LAYER_TEMPLATE_CREATED",
    PROJECT_LAYER_TEMPLATE_EDITED = "PROJECT_LAYER_TEMPLATE_EDITED",
    PROJECT_LAYER_TEMPLATE_DELETED = "PROJECT_LAYER_TEMPLATE_DELETED",
    LAYER_CREATED_FROM_PROJECT_TEMPLATE = "LAYER_CREATED_FROM_PROJECT_TEMPLATE",
    LAYER_UNLINKED_FROM_PROJECT_TEMPLATE = "LAYER_UNLINKED_FROM_PROJECT_TEMPLATE"
}